import {
	AttachRestockSessionKitMutation,
	CancelRestockSessionMutation,
	CreateRestockSessionMutation,
	DeleteRestockSessionMutation,
	SubmitRestockSessionMutation,
	UpdateRestockSessionMutation
} from "~/gql/mutations/restock/restockSession.generated";
import { GetRestockSessionKitsQuery, GetRestockSessionsQuery } from "~/gql/queries/restock/restockSession.generated";

export const restockSessionEndpoints = {
	AttachRestockSessionKit: {
		invalidatesTags: ["RestockSessionKits"] as AddTagTypes,
		transformResponse: (res: AttachRestockSessionKitMutation) => res
	},
	CancelRestockSession: {
		invalidatesTags: ["RestockSessions"] as AddTagTypes,
		transformResponse: (res: CancelRestockSessionMutation) => res
	},
	CreateRestockSession: {
		invalidatesTags: ["RestockSessions"] as AddTagTypes,
		transformResponse: (res: CreateRestockSessionMutation) => res
	},
	DeleteRestockSession: {
		invalidatesTags: ["RestockSessions"] as AddTagTypes,
		transformResponse: (res: DeleteRestockSessionMutation) => res
	},
	GetRestockSessionKits: {
		providesTags: ["RestockSessionKits"] as AddTagTypes,
		transformResponse: (res: GetRestockSessionKitsQuery) => res
	},
	GetRestockSessions: {
		providesTags: ["RestockSessions"] as AddTagTypes,
		transformResponse: (res: GetRestockSessionsQuery) => res
	},
	SubmitRestockSession: {
		invalidatesTags: ["RestockSessions"] as AddTagTypes,
		transformResponse: (res: SubmitRestockSessionMutation) => res
	},
	UpdateRestockSession: {
		invalidatesTags: ["RestockSessions"] as AddTagTypes,
		transformResponse: (res: UpdateRestockSessionMutation) => res
	}
};
